import { render, staticRenderFns } from "./AddEditEDocumentVersion.vue?vue&type=template&id=ce10468c&scoped=true"
import script from "./AddEditEDocumentVersion.vue?vue&type=script&lang=js"
export * from "./AddEditEDocumentVersion.vue?vue&type=script&lang=js"
import style0 from "./AddEditEDocumentVersion.vue?vue&type=style&index=0&id=ce10468c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce10468c",
  null
  
)

export default component.exports